// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1mb65","messages":"Chat_messages__36m28","dateDivider":"Chat_dateDivider__3Nr1f"};